import { isArray } from 'lodash'
import * as services from '../../app/auth/services.js'
import { setToken } from './index.js'
import UTILITY from '../../utils/common.js'

export default (http, store, router) => {
  // https://github.com/mzabriskie/axios#interceptors
  http.interceptors.response.use(
  
    response => {
      $('.pace').removeClass('pace-active');
      $('.pace').addClass('pace-inactive');
      if (response.headers.newauth) {
        let token = response.headers.newauth.split(" ")[1];
        token && store.dispatch('setToken', token);
        UTILITY.setItemLocalStorage('emailRem-token', token)
      }
      return response
    },
    
    /**
    * This is a central point to handle all
    * error messages generated by HTTP
    * requests
    */
    (error) => {
     
      $('.pace').removeClass('pace-active');
      $('.pace').addClass('pace-inactive');
      const { response } = error
      /**
      * If token is either expired, not provided or invalid
      * then redirect to login. On server side the error
      * messages can be changed on app/Providers/EventServiceProvider.php
      */
     
      if (response && response.status &&(response.status == 401 || response.status == 403)) {
        
        
        store.dispatch('setToken', null)
        store.dispatch('setUser', {})
        
        
        // if (router.currentRoute.name !='auth.login'){
          // console.log("Should not come here ")
        router.push({ name: 'auth.login' }).catch(err => {})
        // }
      }
      /**
      * Error messages are sent in arrays
      */
      if (response && isArray(response.data)) {
        store.dispatch('setMessage', { type: 'error', message: response.data })
      /**
      * Laravel generated validation errors are
      * sent in an object
      */
      } else {
        store.dispatch('setMessage', { type: 'validation', message: response && response.data || "" })
      }

      store.dispatch('setFetching', { fetching: false })

      return Promise.reject(error)
    }
  )
}



// WEBPACK FOOTER //
// ./src/plugins/http/interceptors.js